(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["li-header"]) return;
  try {
    
(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  let adding = false;
  const closeDialogs = () => document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const opener = event.target.closest('[data-open], [data-action="quiz"]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.open || 'quiz-dialog');
      if (dialog) { event.preventDefault(); closeDialogs(); dialog.showModal(); }
      return;
    }
    if (event.target.closest('.mobile-nav a')) closeDialogs();
    const photo = event.target.closest('[data-image]');
    if (photo) {
      const image = document.getElementById('ProductImage');
      if (!image) return;
      image.removeAttribute('srcset'); image.src = photo.dataset.image; image.alt = photo.dataset.alt;
      document.querySelectorAll('[data-image]').forEach(button => button.setAttribute('aria-pressed', String(button === photo)));
    }
    const quantity = event.target.closest('[data-quantity]');
    if (quantity) {
      const input = document.getElementById('ProductQuantity');
      input.value = String(Math.max(1, (Number(input.value) || 1) + Number(quantity.dataset.quantity)));
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant]')) {
      const url = new URL(location.href); url.searchParams.set('variant', event.target.value); location.assign(url.href);
    }
    if (event.target.matches('[data-plan]')) {
      const option = event.target.selectedOptions[0];
      const price = document.getElementById('product-price');
      if (price && option) price.textContent = option.dataset.price;
      const mobilePrice = document.querySelector('.product-mobile-bar span');
      if (mobilePrice && option) mobilePrice.textContent = option.dataset.price;
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.native-product-form')) return;
    event.preventDefault();
    if (adding || !form.reportValidity()) return;
    adding = true;
    const buttons = [...document.querySelectorAll('#ProductForm button[type="submit"], button[form="ProductForm"]')];
    const states = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    const error = form.querySelector('[data-product-error]');
    error.textContent = '';
    let added = false;
    try {
      const body = new FormData(form);
      if (!body.get('selling_plan')) body.delete('selling_plan');
      const response = await fetch(root + 'cart/add.js', {method: 'POST', body, headers: {Accept: 'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This product could not be added. Please try again.');
      added = true;
      const url = new URL(location.href); url.pathname = root; url.searchParams.set('section_id', 'li-cart-drawer');
      const drawerResponse = await fetch(url);
      if (!drawerResponse.ok) throw new Error('Your product was added. Open your bag to review it.');
      const parsed = new DOMParser().parseFromString(await drawerResponse.text(), 'text/html');
      const newDialog = parsed.getElementById('cart-dialog');
      const current = document.getElementById('cart-dialog');
      if (!newDialog || !current) throw new Error('Your product was added. Open your bag to review it.');
      closeDialogs(); current.replaceWith(newDialog);
      const count = newDialog.querySelector('[data-cart-count]')?.textContent || '';
      document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = count; });
      newDialog.showModal();
      document.getElementById('live-status').textContent = 'Added to your bag.';
    } catch (failure) {
      if (added) location.assign(root + 'cart');
      else error.textContent = failure.message || 'Could not add this product. Please try again.';
    } finally {
      adding = false; buttons.forEach((button, index) => { button.disabled = states[index]; });
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
